import {T} from '../../utils/I18n/I18n';
import QuarticonProductSlider from "../../renderComponents/ProductsSlider/QuarticonProductSlider";
import React from "react";
import {Helmet} from "react-helmet-async";

const EmptyListing = ()=>{
    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <h1>
                <T id="category.noProductAlert"/>
            </h1>
            {<QuarticonProductSlider type="no_search" cnt={4}/>}

        </>
    );
}

export default EmptyListing;
